export default __webpack_public_path__ + "static/media/haste-w200.c5fa21f0.png";